import React from "react"

const FORCEFUL_CARD_NEEDED = "Please add a payment method before your appointment."
const SOFT_CARD_NEEDED = "Paying by credit card? You can add your card before your appointment."

const PaymentStatusBox = ({ appointment }) => {
  const { clientPaymentStatus: status, defaultPaymentMethodData: paymentMethod } = appointment
  const requireClientCcToBook = Boolean(appointment.practice?.requireClientCcToBook)

  if (status === "Free") return <></>

  let statusMessage = {
    Paid: "Your payment has been processed successfully.",
    Failed: "Your payment has failed. Please retry or add a new payment method.",
    Pending: "Your payment method will be charged after your appointment.",
    "Card needed": requireClientCcToBook ? FORCEFUL_CARD_NEEDED : SOFT_CARD_NEEDED,
    "Card needed past due": "Your payment is past due. Please add a credit card to pay for your appointment.",
    "Past due": "Your payment is past due. Please add a credit card or retry the card on file"
  }[status]

  if ((status === "Past due" || status === "Pending") && paymentMethod) {
    statusMessage += ` (${paymentMethod.brand} ending in ${paymentMethod.last4})`
  }

  const isSoftCardNeeded = status === "Card needed" && !requireClientCcToBook
  const isAlert = status !== "Paid" && status !== "Pending" && !isSoftCardNeeded

  return (
    <div className={`my-4 rounded p-4 ${isAlert ? "bg-red-light" : "bg-offwhite"}`}>
      {isAlert && <i className="icon-warning-icon mr-1" />}
      {statusMessage}
    </div>
  )
}

export default PaymentStatusBox
